import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { settingSetGuarantor } from 'services/setting'
import posthog from 'posthog-js'

export default function useSetGuarantor(refetch: () => void) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISetGuarantorSettingPayload) => {
            return settingSetGuarantor(payload)
        },
        onSuccess: (data, variables: any) => {
            posthog.capture('member_guarantor_changed', {
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
            })
            refetch()
            toast.success('با موفقیت تغییر یافت')
        },
        onError: (error: any, variables: any) => {
            posthog.capture('member_action_failed', {
                action: 'change_guarantor',
                fund_id: variables?.id ?? variables?.moneyPool,
                poolship_id: variables?.poolShip,
                status: error?.response?.status,
            })
            toast.error('مشکلی پیش آمده!')
        },
    })

    return { mutate }
}
